import { allTrackers } from "app/services/track/track";

import createCompanyAnalysisCompanyTrackingService from "./factory";

const companyAnalysisTrackingService = createCompanyAnalysisCompanyTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default companyAnalysisTrackingService;
